import React from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { Typography } from '@fiverr-private/typography';
import { FILTER } from '@fiverr-private/listing_lib';
import type {
    ActiveSideFiltersType,
    SelectedFilterOption as SelectedFilterOptionType,
} from '@fiverr-private/listing_types';
import { filterNavigation } from '../../../../../../service/clientNavigation';
import { ActiveFilterAlias } from '../../../../side_filters/ActiveFiltersSection/ActiveFilter/ActiveFilterAlias/ActiveFilterAlias';
import { ActiveFilterOptionCount } from '../../../../side_filters/ActiveFiltersSection/ActiveFilter/ActiveFilterOptionCount/ActiveFilterOptionCount';
import { ID_TO_CHANGE_OBJECT } from '../../../../side_filters/ActiveFiltersSection/ActiveFilter/ActiveFilter.config';
import { PillButton } from '../../../../pill_button';

interface SelectedFilterChipProps {
    id: string;
    activeFilters: ActiveSideFiltersType;
    alias: string;
    values: SelectedFilterOptionType[];
}

export const SelectedFilterChip = ({ id, alias = '', values, activeFilters }: SelectedFilterChipProps) => {
    const { alias: firstOptionAlias, activeFilterAlias: firstOptionActiveFilterAlias } = values[0] || {};

    const onClick = () => {
        const change = (ID_TO_CHANGE_OBJECT[id] ?? (() => ({ [id]: [] })))(activeFilters);
        const params = id === FILTER.SUB_CATEGORIES.ID ? {} : null;

        filterNavigation(change, activeFilters, null, null, null, params);
    };

    return (
        <PillButton isActive onClick={onClick}>
            {/* Single child: PillButton's own gap would otherwise stack with this one. */}
            <Stack gap="1" alignItems="center">
                <Stack gap="1">
                    <ActiveFilterAlias alias={alias} />
                    <Typography as="span" fontSize="b_md" fontWeight="semibold">
                        {firstOptionActiveFilterAlias || firstOptionAlias}
                    </Typography>
                </Stack>
                <ActiveFilterOptionCount options={values} withLeadingSpace={false} />
            </Stack>
        </PillButton>
    );
};
